module.exports = __webpack_public_path__ + "static/img/xl1.6e17946.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/xl1.png
// module id = XYs7
// module chunks = 7